import {
    DataArray,
    UpdateIconButton,
    pn,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from "@compass/core";
import { ListBeProperty } from "components";
import { RegionListDto, RegionListResource, Permission, PermissionAction, SortObject } from "generated/openApi";
import { useNavigate } from "react-router-dom";
import { isAuthorized } from "services";
import { regionPageRoute } from "../RegionPage/RegionPage";

export const RegionTable = (props: {
    rootPermission: Permission;
    tableContainerRef: React.RefObject<HTMLDivElement>;
    regions: RegionListDto[];
    setRegions: (regions: RegionListDto[]) => void;
    resource: RegionListResource;
    searchFocused: boolean;
    sortObjects: SortObject[] | undefined;
    sort: (sortObjects: SortObject[]) => void;
    loadList: () => void;
}) => {
    const navigate = useNavigate();
    const properties = props.resource.properties || [];

    return (
        <TableContainer ref={props.tableContainerRef}>
            <Table stickyHeader>
                <TableHead>
                    <TableRow>
                        <TableCell style={{ width: "7%"}}>
                            <ListBeProperty
                                listProperty={properties.find((x) => x.propertyName === pn<RegionListDto>("id"))}
                                searchFocused={props.searchFocused}
                                sortObjects={props.sortObjects}
                                onChange={(sortObjects) => props.sort(sortObjects)}
                            />
                        </TableCell>
                        <TableCell>
                            <ListBeProperty
                                listProperty={properties.find((x) => x.propertyName === pn<RegionListDto>("name"))}
                                searchFocused={props.searchFocused}
                                sortObjects={props.sortObjects}
                                onChange={(sortObjects) => props.sort(sortObjects)}
                            />
                        </TableCell>
                        <TableCell>
                            <ListBeProperty
                                listProperty={properties.find((x) => x.propertyName === pn<RegionListDto>("districts"))}
                                searchFocused={props.searchFocused}
                                sortObjects={props.sortObjects}
                                onChange={(sortObjects) => props.sort(sortObjects)}
                            />
                        </TableCell>
                        <TableCell></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {props.regions.map((regionItem) => (
                        <TableRow
                            key={regionItem.id}
                            onClick={() =>
                                navigate(
                                    regionPageRoute.getPath({
                                        id: regionItem.id,
                                        crudMode: "view",
                                        screenType: "dialog"
                                    })
                                )
                            }
                        >
                            <TableCell>{regionItem.id}</TableCell>
                            <TableCell>{regionItem.name}</TableCell>
                            <TableCell>
                                <DataArray value={regionItem.districts} max={3} />
                            </TableCell>
                            <TableCell type="action">
                                {isAuthorized(props.rootPermission, PermissionAction.Update) && (
                                    <UpdateIconButton color="primary"
                                        onClick={() =>
                                            navigate(
                                                regionPageRoute.getPath({
                                                    id: regionItem.id,
                                                    crudMode: "edit",
                                                    screenType: "dialog"
                                                })
                                            )
                                        }
                                    />
                                )}
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};